export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10086.e6c87da8.jpg";